module.exports = __webpack_public_path__ + "static/scale-model-of-go-rio-san-antonio-river-cruises-in-san-antonio-texas-7d83140ca8267a450a7f590e56d61102.png";